import { render } from "./ShoppingCard.vue?vue&type=template&id=2e9e71ce&scoped=true"
import script from "./ShoppingCard.vue?vue&type=script&lang=js"
export * from "./ShoppingCard.vue?vue&type=script&lang=js"

import "./ShoppingCard.vue?vue&type=style&index=0&id=2e9e71ce&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9e71ce"]])

export default __exports__